<template>
  <page>
    <template v-slot:content>
      <v-container fluid py-0>
        <v-row>
          <v-col cols="12" sm="6" md="8">
            <v-card class="mb-4">
              <v-card-title class="primary white--text">Stats</v-card-title>
              <v-row class="px-2">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  xl="2"
                  v-for="(card, index) in cardItems"
                  :key="index"
                >
                  <v-card>
                    <div class="cardStatBorder pa-2">
                      <div class="cardValue">{{ card.value }}</div>
                      <div class="cardTitle">{{ card.title }}</div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-overlay
                :absolute="true"
                :opacity="overlayOpacity"
                :value="true"
                color="white"
              />
            </v-card>
            <v-card class="mb-4">
              <v-card-title class="primary white--text"
                >Performance</v-card-title
              >
              <v-row class="px-2">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  xl="2"
                  v-for="(perf, index) in performanceItems"
                  :key="index"
                >
                  <div style="text-align:center">
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="12"
                      :value="perf.value"
                      :color="getProgressColour(perf.value)"
                      >{{ perf.value }}%</v-progress-circular
                    >
                    <div class="pt-2 perfTitle">{{ perf.title }}</div>
                  </div>
                </v-col>
              </v-row>
              <v-overlay
                :absolute="true"
                :opacity="overlayOpacity"
                :value="true"
                color="white"
              />
            </v-card>
            <v-card class="mb-4">
              <v-card-title class="primary white--text">Targets</v-card-title>
              <v-row class="px-2">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="(card, index) in cardItems"
                  :key="index"
                >
                  <v-card>
                    <div class="cardStatBorder pa-2">
                      <div class="cardValue">{{ card.value }}</div>
                      <div class="cardTitle">{{ card.title }}</div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-overlay
                :absolute="true"
                :opacity="overlayOpacity"
                :value="true"
                color="white"
              />
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card class="mb-4">
              <v-card-title class="primary white--text">Alerts</v-card-title>
              <div
                v-for="(alert, index) in alertItems"
                :key="index"
                class="pa-2"
              >
                <v-menu v-model="alert.dialog" offset-y open-on-hover>
                  <template v-slot:activator="{ on }">
                    <v-card v-on="on" class="pa-0">
                      <div class="cardErrorBorder pa-2">
                        <div class="cardValueError">
                          <span style="color:red">{{ alert.value }}</span>
                          <span>{{ ' ' + alert.title }}</span>
                        </div>
                        <div class="cardTitleError">{{ alert.action }}</div>
                        <font-awesome-icon
                          class="cardIconError"
                          prefix="far"
                          :icon="alert.icon"
                          size="lg"
                        />
                      </div>
                    </v-card>
                  </template>
                  <dialog-list
                    :items="alert.items"
                    :total="alert.value"
                    v-on:view="viewCandidate"
                  ></dialog-list>
                </v-menu>
              </div>
            </v-card>
            <v-card class="mb-4">
              <v-card-title class="primary white--text">Quick Add</v-card-title>
              <div class="py-4">
                <v-slide-group multiple show-arrows>
                  <v-slide-item
                    v-for="(add, index) in quickAddItems"
                    :key="index"
                  >
                    <v-btn
                      class="mx-2"
                      depressed
                      rounded
                      @click="quickAdd(add)"
                      color="blue"
                      dark
                      >{{ add }}</v-btn
                    >
                  </v-slide-item>
                </v-slide-group>
              </div>
            </v-card>
            <v-card class="mb-4">
              <v-card-title class="primary white--text"
                >Quick Search</v-card-title
              >
              <div class="pa-4">
                <v-text-field
                  label="Search"
                  filled
                  outlined
                  append-icon="mdi-magnify"
                  hide-details
                ></v-text-field>
              </div>
              <v-overlay
                :absolute="true"
                :opacity="overlayOpacity"
                :value="true"
                color="white"
              />
            </v-card>
            <v-card class="mb-4">
              <v-card-title class="primary white--text"
                >Document Dropzone</v-card-title
              >
              <div class="pa-4">
                <vue-dropzone
                  id="1"
                  :options="dropzoneOptions"
                  :useCustomSlot="true"
                  class="grey lighten-4"
                >
                  <div class="dropzone-custom-content">
                    <font-awesome-icon prefix="far" icon="upload" size="lg" />
                    <h3 class="dropzone-custom-title">
                      Drag and drop to upload a document!
                    </h3>
                    <div class="subtitle">
                      ...or click to select a file from your computer
                    </div>
                  </div>
                </vue-dropzone>
              </div>
              <v-overlay
                :absolute="true"
                :opacity="overlayOpacity"
                :value="true"
                color="white"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import dialogList from '@/components/dialog_list';

export default {
  components: {
    vueDropzone: vue2Dropzone,
    dialogList
  },
  data() {
    return {
      overlayOpacity: 0.6,
      quickAddItems: ['Job', 'Candidate', 'Client', 'Timesheet', 'Document'],
      cardItems: [
        {
          value: '109',
          title: 'Jobs'
        },
        {
          value: '156',
          title: 'Active Workers'
        },
        {
          value: '87%',
          title: '% Attendence'
        },
        {
          value: '7',
          title: 'New Signups'
        },
        {
          value: '1',
          title: 'New Clients'
        },
        {
          value: '95%',
          title: 'Job Fulfillment'
        }
      ],

      performanceItems: [
        {
          value: 23,
          title: 'New Leads'
        },
        {
          value: 123,
          title: 'Meetings'
        },
        {
          value: 83,
          title: 'Sales Calls'
        },
        {
          value: 10,
          title: 'New Candidates'
        },
        {
          value: 150,
          title: 'Jobs Completed'
        },
        {
          value: 52,
          title: 'Jobs Created'
        }
      ],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        addRemoveLinks: true
      }
    };
  },
  computed: {
    ...mapState({
      account: state => state.account,
      temp: state => state.temp
    }),
    candidates() {
      return this.temp.stats.candidates;
    },
    alertItems() {
      var items = [];
      if (this.candidates == null) {
        return items;
      }
      if (this.candidates.incomplete.length > 0) {
        items.push({
          value: this.candidates.incomplete.length,
          title: 'Candidates',
          action: 'Incomplete',
          icon: 'user',
          dialog: false,
          items: this.candidates.incomplete.slice(0, 10)
        });
      }

      if (this.candidates.alerts.length > 0) {
        items.push({
          value: this.candidates.alerts.length,
          title: 'Expired Dates',
          action: 'Overdue',
          icon: 'calendar-day',
          dialog: false,
          items: this.candidates.alerts.slice(0, 10)
        });
      }
      return items;
    }
  },
  methods: {
    ...mapActions({
      fetch: 'temp/fetch'
    }),
    getProgressColour(val) {
      if (val < 50) {
        return 'red';
      } else if (val < 100) {
        return 'amber';
      } else {
        return 'green';
      }
    },
    quickAdd(type) {
      switch (type) {
        case 'Job':
          this.$router.push('temp/planner?new=true');
          break;
        case 'Candidate':
          this.$router.push('temp/candidates?new=true');
          break;
        case 'Client':
          this.$router.push('temp/clients?new=true');
          break;
        case 'Timesheet':
          this.$router.push('temp/timesheets?new=true');
          break;
      }
    },
    viewCandidate(item) {
      this.$router.push(`temp/candidates?id=${item._id}`);
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style>
.cardStatBorder {
  border-left: 6px solid #2196f3;
}

.cardErrorBorder {
  border-left: 6px solid red;
}

.cardTitle {
  text-align: right;
  opacity: 0.6;
}

.cardValue {
  font-size: 2em;
  font-weight: 900;
  text-align: right;
}

.cardTitleError {
  text-align: left;
  opacity: 0.6;
}

.perfTitle {
  font-weight: 600;
  font-size: 1em;
  opacity: 0.4;
}

.cardValueError {
  font-size: 1.8em;
  font-weight: 600;
  opacity: 0.8;
  text-align: left;
}

.cardIconError {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0%, -50%);
}

.dropzone-custom-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.dropzone-custom-title {
  color: #2196f3;
  padding: 20px 0px;
}

.subtitle {
  color: #314b5f;
  font-size: 0.8em;
}
</style>
